/**
 * Frontend feature flags.
 *
 * Flip a flag here to show/hide a feature across the whole app without
 * touching individual components. Keep flags boolean and documented.
 */

/**
 * Night / dark mode.
 * Temporarily disabled (2026-10-02): the dark theme needs a full styling pass
 * before it is user-ready. While false:
 *  - all theme toggles (sidebar, dashboard header, auth pages) are hidden
 *  - ThemeProvider forces the light theme, even if a user previously saved 'dark'
 *  - onboarding/help copy about dark mode is omitted
 */
export const DARK_MODE_ENABLED = false;
